exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".d-ib {\n  padding: 0;\n  padding-left: 10px;\n  font-size: 1.2em;\n  text-transform: uppercase; }\n  .d-ib strong {\n    display: none; }\n\n.subtitle {\n  background: #365ba0;\n  padding: 10px;\n  margin: 0 !important; }\n  .subtitle h5 {\n    color: white !important; }\n\n.subcontent {\n  padding: 0; }\n\n.hide {\n  display: none; }\n\n.show {\n  display: block; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/form/form/commerce-general-form/commerce-general-form.component.scss
// module id = 930
// module chunks = 0